import { render, staticRenderFns } from "./LoginBridge.vue?vue&type=template&id=8c05cdf0&scoped=true"
import script from "./LoginBridge.vue?vue&type=script&lang=js"
export * from "./LoginBridge.vue?vue&type=script&lang=js"
import style0 from "./LoginBridge.vue?vue&type=style&index=0&id=8c05cdf0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c05cdf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c05cdf0')) {
      api.createRecord('8c05cdf0', component.options)
    } else {
      api.reload('8c05cdf0', component.options)
    }
    module.hot.accept("./LoginBridge.vue?vue&type=template&id=8c05cdf0&scoped=true", function () {
      api.rerender('8c05cdf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/LoginBridge.vue"
export default component.exports